import mcmasterImg from './images/mcmaster-med.jpg';
import medSpecsImg from './images/med-specs.jpg';
import queensImg from './images/queens-exploring-med.jpg';
import sfuImg from './images/sfu-pre-med.jpg';
import torontoHBSU from './images/toronto-hbsu.jpg';
import torontoImg from './images/toronto-pre-med.jpg';
import ubcImg from './images/ubc-pre-med.jpg';
import westernImg from './images/western-pre-med.jpg';

export default {
  mcmaster_med: { logo: mcmasterImg, name: 'McMaster Medicine and Health Society' },
  queens_exploring_med: { logo: queensImg, name: "Queen's University Exploring Medicine Association" },
  sfu_pre_med: { logo: sfuImg, name: 'SFU Pre-Med Society' },
  toronto_pre_med: { logo: torontoImg, name: 'U of T Pre-Medical Students Association' },
  ubc_pre_med: { logo: ubcImg, name: 'UBC Pre-Med Society' },
  western_pre_med: { logo: westernImg, name: 'Western Pre-Med' },
  toronto_hbsu: { logo: torontoHBSU, name: 'U of T Human Biology Students Union' },
  med_specs: { logo: medSpecsImg, name: 'McGill MedSpecs' },
};
